import React, { useRef, useEffect } from 'react';

/** dataTransfer key carrying the connector-type id dragged from the types panel. */
export const CONNECTOR_TYPE_DND = 'application/x-connector-type';

interface CanvasContainerProps {
  onCanvasReady: (container: HTMLDivElement) => void;
  /** Called when a connector type is dropped on the canvas, with page coordinates. */
  onConnectorTypeDrop?: (typeId: string, clientX: number, clientY: number) => void;
}

export const CanvasContainer: React.FC<CanvasContainerProps> = ({
  onCanvasReady,
  onConnectorTypeDrop
}) => {
  const canvasRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (canvasRef.current) {
      onCanvasReady(canvasRef.current);
    }
  }, [onCanvasReady]);

  const handleDrop = (event: React.DragEvent) => {
    const typeId = event.dataTransfer.getData(CONNECTOR_TYPE_DND);
    if (typeId) {
      event.preventDefault();
      onConnectorTypeDrop?.(typeId, event.clientX, event.clientY);
    }
  };

  const handleDragOver = (event: React.DragEvent) => {
    // Allow dropping connector types onto the canvas.
    if (event.dataTransfer.types.includes(CONNECTOR_TYPE_DND)) {
      event.preventDefault();
    }
  };

  return (
    <div
      ref={canvasRef}
      style={{
        flex: 1,
        minWidth: 0,
        height: '100%',
        position: 'relative',
        overflow: 'hidden'
      }}
      onContextMenu={(e) => e.preventDefault()}
      onDrop={handleDrop}
      onDragOver={handleDragOver}
    />
  );
};

// Add default export
export default CanvasContainer;